import { render, staticRenderFns } from "./TransferenciaItemsView.vue?vue&type=template&id=2639cd1a&scoped=true&"
import script from "./TransferenciaItemsView.vue?vue&type=script&lang=js&"
export * from "./TransferenciaItemsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2639cd1a",
  null
  
)

export default component.exports